var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.783 18.848L230.92 245.963 3.783 473.078c-4.093 4.237-3.975 10.99.262 15.083 4.134 3.992 10.687 3.992 14.82 0l234.667-234.667c4.164-4.165 4.164-10.917 0-15.083L18.865 3.744C14.772-.493 8.02-.61 3.782 3.482-.455 7.575-.572 14.327 3.52 18.565c.086.09.173.176.262.262l.001.021z"}));
}

ArrowRight.defaultProps = {"height":"491.66","width":"257.139","viewBox":"0 0 257.139 491.66"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
